<section class="white-bg xs-pb-100" id="about">
  <div class="container">
    <div class="row story-layout">
      <div class="col-md-6 col-sm-12 text-left mt-50 xs-mt-0">
        <div class="section-title mb-50">
          <h2
            class="mt-0 home-about-header brand-mark"
            [appSplitText]="'home.design.aboutLabel' | translate"
            splitMode="reveal"
          ></h2>
          <h2
            class="mt-30 font-50px font-300"
            [appSplitText]="'home.design.aboutTitle' | translate"
            splitMode="reveal"
          ></h2>
        </div>
        <p appReveal="rise" revealDelay="0.15">
          {{ "home.about.intro" | translate }}
        </p>

        <p class="mt-30 mb-0" appReveal="rise" revealDelay="0.25">
          <a class="dv-pill dv-pill--dark cta-sheen" appMagnetic [routerLink]="link('/about')">
            <span class="magnetic-label">{{ "readMore-btn" | translate }}</span>
            <span class="brand-icon brand-icon--arrow dv-arrow" aria-hidden="true"></span>
          </a>
        </p>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="responsive-screen">
          <div class="story-frame">
            <img
              src="assets/images/background/girl.jpg"
              alt="driving-girl"
              width="1170"
              height="780"
            />
          </div>
          <div class="story-caption"><span class="story-caption-mark" aria-hidden="true"><span class="brand-icon brand-icon--arrow"></span></span><span>{{ 'home.design.aboutNote' | translate }}</span></div>
        </div>
      </div>
    </div>
  </div>
</section>
